import { ValidationErrors } from 'ngrx-forms';
import * as moment from 'moment';

export function maxDate(max: string, utc = true) {
  let comparand = moment.parseZone(max);
  if (utc) {
    comparand = comparand.utc();
  }

  return (value: string): ValidationErrors => {
    if (!value) {
      return {};
    }

    let dateVal = moment.parseZone(value);
    if (utc) {
      dateVal = dateVal.utc();
    }

    if (dateVal.isSameOrBefore(comparand)) {
      return {};
    }

    return {
      maxDate: {
        max: comparand.format(),
        actual: value
      }
    };
  };
}
